import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EquipmentFunctionModelSelectionCriteriaBase } from '../../viewmodels/equipment/equipment-function-model-selection-criteria-base';
import { DynamicFormControlService } from '../dynamic-forms/dynamic-form-control.service';
import { FormControlBase, TextBoxControl } from '../dynamic-forms/form-models/form-control-base';
import { IIsoHierarchyDataSelectionLoadService } from './iso-hierarchy-data-selection-load-service';

@Component({
  selector: 'hb-equipment-function-model-selection-criteria-dialog',
  templateUrl: './equipment-function-model-selection-criteria-dialog.component.html',
  styleUrls: ['./equipment-function-model-selection-criteria-dialog.component.scss'],
})
export class EquipmentFunctionModelSelectionCriteriaDialogComponent implements OnInit, OnDestroy {
  public criteria: EquipmentFunctionModelSelectionCriteriaBase;
  public formGroup: FormGroup;

  public modelNameControl = new TextBoxControl({
    key: 'modelName',
    label: this.i18NextPipe.transform('FunctionModelSelectionCriteriaDialog.FoundModel'),
    disabled: true,
  });

  public dataLoadService: IIsoHierarchyDataSelectionLoadService;
  private controls: FormControlBase<any>[] = [this.modelNameControl];
  private unsubscribe: Subject<boolean> = new Subject();

  constructor(public bsModalRef: BsModalRef, private dynamicFormControlService: DynamicFormControlService, private i18NextPipe: I18NextPipe) {}

  ngOnInit() {
    this.formGroup = this.dynamicFormControlService.toFormGroup(this.controls);
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  initialize(dataLoadService: IIsoHierarchyDataSelectionLoadService) {
    this.dataLoadService = dataLoadService;

    this.criteria = this.dataLoadService.createCriteria();
    this.criteria.excludedModelIds = this.dataLoadService.excludedDataIds;

    this.dataLoadService.invalidCriteriaSelected.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.modelNameControl.value = this.i18NextPipe.transform('FunctionModelSelectionCriteriaDialog.None');
    });

    this.dataLoadService.selectionCriteriaChanged.pipe(takeUntil(this.unsubscribe)).subscribe(updatedCriteria => {
      this.applyUpdatedCriteria(updatedCriteria);
    });
  }

  applyUpdatedCriteria(updatedCriteria: EquipmentFunctionModelSelectionCriteriaBase) {
    this.criteria = updatedCriteria;
    this.dynamicFormControlService.setModel(this.criteria, this.controls);
    this.modelNameControl.value = this.criteria.modelName();
  }

  confirmLoad() {
    if (!this.criteria.hasModel()) {
      return;
    }

    this.dataLoadService.selectData(this.criteria);
    this.bsModalRef.hide();
  }

  foundModel(): boolean {
    if (!this.dataLoadService) {
      return false;
    }

    return this.dataLoadService.validateCriteria(this.criteria) && this.criteria.hasModel();
  }
}
